import { Component, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'mono-common-modal-confirmation',
  templateUrl: './modal-confirmation.component.html'
})
export class ModalConfirmationComponent implements OnInit, AfterViewInit {

  @Input() title: string;
  @Input() description: string;
  @Input() confirmText: string;
  @Input() cancelText: string;
  @Input() disableConfirm: boolean;

  @Output() confirmClick = new EventEmitter();
  @Output() cancelClick = new EventEmitter();

  @ViewChild('modal') modal: ElementRef;
  @ViewChild('button1') firstFocusableElement: ElementRef;
  @ViewChild('button2') lastFocusableElement: ElementRef;

  constructor(private renderer: Renderer2, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.hideModalOnPressingEscape()
  }

  ngAfterViewInit(): void {
    this.trapFocusInModal();
  }

  public confirmClicked() {
    this.confirmClick.emit();
  }

  public cancelClicked() {
    this.cancelClick.emit();
  }

  private trapFocusInModal() {
    this.renderer.listen(this.document, 'keydown', (event) => {
      const tabIsPressed = this.checkForTabPressed(event);
      if (!tabIsPressed) {
        return;
      }
      if (event.shiftKey) {
        this.checkForFirstFocusableElement(event);
      } else {
        this.checkForLastFocusableElement(event);
      }
    });
    this.modal.nativeElement.focus();
  }

  private checkForTabPressed(event) {
    return event.key === 'Tab' || event.keyCode === 9;
  }

  private checkForFirstFocusableElement(event) {
    if (this.document.activeElement === this.firstFocusableElement.nativeElement) {
      this.lastFocusableElement.nativeElement.focus();
    }
  }

  private checkForLastFocusableElement(event) {
    if (this.document.activeElement === this.lastFocusableElement.nativeElement) {
      this.firstFocusableElement.nativeElement.focus();
    }
  }

  public hideModalOnClick() {
    this.cancelClicked();
  }

  private hideModalOnPressingEscape() {
    const escapeKeyCode = 27;
    this.renderer.listen(
      this.document, 'keydown', (event) => {
        if (event.keyCode === escapeKeyCode) {
          this.cancelClicked();
        }
      }
    );
  }

}